import { WifiOff, X } from "lucide-react"
import { useEffect, useState } from "react"

import { useOnlineStatus } from "@/hooks/use-online-status"

export function OfflineBanner() {
  const isOnline = useOnlineStatus()
  const [isDismissed, setIsDismissed] = useState(false)

  useEffect(() => {
    if (isOnline) {
      setIsDismissed(false)
    }
  }, [isOnline])

  if (isOnline || isDismissed) {
    return null
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-amber-950 px-4 py-2">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-2">
          <WifiOff className="h-4 w-4" />
          <span className="text-sm font-medium">
            Você está offline. Algumas funcionalidades podem estar
            indisponíveis.
          </span>
        </div>
        <button
          type="button"
          onClick={() => setIsDismissed(true)}
          className="p-1 hover:bg-amber-600 rounded transition-colors"
          aria-label="Fechar aviso"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
